import { resolveMediaUrl } from "../../lib/api";

export const SecondaryImagesGrid = ({ images }) => {
  if (!images || images.length === 0) return null;
  return (
    <div data-testid="secondary-images-grid" className="grid grid-cols-2 sm:grid-cols-3 gap-4">
      {images.map((img, idx) => (
        <img
          key={`${img}-${idx}`}
          src={resolveMediaUrl(img)}
          alt=""
          data-testid={`secondary-image-${idx}`}
          className="h-40 md:h-52 w-full object-cover border border-white/10"
        />
      ))}
    </div>
  );
};
